import { render, staticRenderFns } from "./ReviewDomain.vue?vue&type=template&id=d1000772&scoped=true"
import script from "./ReviewDomain.vue?vue&type=script&lang=js"
export * from "./ReviewDomain.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomain.vue?vue&type=style&index=0&id=d1000772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1000772",
  null
  
)

export default component.exports